import apis from "../../utils/apis";
import { SIGN_DOCUMENT_REQUEST, SIGN_DOCUMENT_SUCCESS } from "../types";
import { handleApiError } from "./utils/utils";


export const signDocument = (fileId: string, callback?: () => void) => async (dispatch: any) => {
  dispatch({ type: SIGN_DOCUMENT_REQUEST });
  try {
    const response : any = await apis({
        method: "POST",
        url: `/files/${fileId}/sign`,
    })
    if(response && response.status === 200){
      dispatch({ type: SIGN_DOCUMENT_SUCCESS, payload: response.data });
      if (callback) callback();

    }else{
      handleApiError(response, dispatch)
    }
  } catch (error: any) {
    handleApiError(error, dispatch)
  }
};

